import PropTypes from "prop-types";
// @mui
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

// ----------------------------------------------------------------------

// Branding 2026: indicador de carga circular, igual que el de las tablas.
// Antes era una barra lineal.
export default function LoadingScreen({ sx, ...other }) {
  return (
    <Box
      sx={{
        px: 5,
        width: 1,
        flexGrow: 1,
        minHeight: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...sx,
      }}
      {...other}
    >
      <CircularProgress
        size={48}
        thickness={3.6}
        color="primary"
      />
    </Box>
  );
}

LoadingScreen.propTypes = {
  sx: PropTypes.object,
};
